<div style="display: flex; flex-direction: column; height: 100%; justify-content: space-between;">
  <app-navbar></app-navbar>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>


<shr-modal id="notification">
  <h4 style="border-bottom: 1px solid; padding: 10px">
    اطلاعیه
  </h4>
  <!-- <p>
    سرمایه‌گذاران گرامی
  </p>
  <p>
    به اطلاع می‌رساند، امکان خرید خودرو (فیدلیتی، دیگنیتی) از طریق بورس کالای کارگزاری آبان امکان‌پذیر می‌باشد، در صورت
    تمایل جهت کسب اطلاعات بیشتر با شماره <a href="tel:+982185510">۰۲۱۸۵۵۱۰</a> تماس حاصل فرمایید.
  </p>
  <br> -->
  <p>
    سرمایه‌گذاران محترم
  </p>
  <p>
    خواهشمند است در صورتی که تا کنون اقدام به ثبت نام و احراز هویت سامانه سجام ننموده‌اید، هر چه سریعتر نسبت به این امر
    اقدام نمایید.
  </p>
  <p>
    لینک ثبت نام: <a href="https://sejam.aban.net" target="_blank">https://sejam.aban.net</a>
  </p>
</shr-modal>